import React, { ReactNode } from "react";

interface RegistroTabelaProps {
  children: ReactNode;
  id: string;
  className?: string;
  isCheckBox?: boolean;
}

export const RegistroTabela: React.FC<RegistroTabelaProps> = (props) => {
  let className = "td-gc ";
  if (props.isCheckBox) {
    className += "td-checkBox ";
  }

  return (
    <td id={props.id} className={className + (props.className ? props.className : "") || ""}>
      {props.children}
    </td>
  );
};
